import { useTranslation } from 'react-i18next'

import { NonProfitDetailListItem } from '../nonProfitDetailListItem/NonProfitDetailListItem'

import { ReactComponent as PencilSVG } from '@percent/admin-dashboard/common/assets/images/pencil.svg'
import { ListItemButton } from '@percent/admin-dashboard/common/components/listItemButton/ListItemButton'
import { getProperHref } from '@percent/admin-dashboard/common/utility/getProperHref'
import { Badge, Spacer } from '@percent/lemonade'
import { Validation } from '@percent/admin-dashboard/api/actions/admin/admin.types'

type WebsiteSectionProps = {
  validation: Validation | undefined
  vrReviewWebsiteFeatureFlag: boolean
  inputsEditable: boolean
  setWebsiteModalOpened: (open: boolean) => void
  setEditWebsiteModalOpened: (open: boolean) => void
}

export function WebsiteSection({
  validation,
  vrReviewWebsiteFeatureFlag,
  inputsEditable,
  setWebsiteModalOpened,
  setEditWebsiteModalOpened
}: WebsiteSectionProps) {
  const { t } = useTranslation()

  const showNotYetIdentified =
    vrReviewWebsiteFeatureFlag &&
    validation?.website &&
    validation?.websiteInvalidReason &&
    !validation?.verifiedWebsite

  return (
    <NonProfitDetailListItem title={t('table.website')}>
      {showNotYetIdentified ? (
        <span>{t('typography.websiteStatus.notYetIdentified')}</span>
      ) : (
        <>
          <a
            href={getProperHref(String(validation?.verifiedWebsite || validation?.website))}
            target="_blank"
            rel="noopener noreferrer"
          >
            {validation?.verifiedWebsite || validation?.website}
          </a>
          {vrReviewWebsiteFeatureFlag && validation?.website && validation?.websiteVerifiedAt && (
            <>
              <Spacer size={2} />
              <Badge
                variant={validation.websiteInvalidReason && !validation.verifiedWebsite ? 'critical' : 'positive'}
                icon={validation.websiteInvalidReason && !validation.verifiedWebsite ? 'reject' : 'approve'}
              >
                {validation.websiteInvalidReason && !validation.verifiedWebsite
                  ? t(`typography.websiteStatus.invalid.${validation.websiteInvalidReason}`)
                  : t('typography.websiteStatus.valid')}
              </Badge>
            </>
          )}
          {vrReviewWebsiteFeatureFlag && validation?.website && !validation?.websiteVerifiedAt && (
            <>
              <Spacer size={2} />
              <Badge variant="warning" icon="flag">
                {t('typography.websiteStatus.pending')}
              </Badge>
            </>
          )}
        </>
      )}
      {inputsEditable && vrReviewWebsiteFeatureFlag && validation?.website && (
        <ListItemButton
          title={validation?.websiteVerifiedAt ? t('button.editWebsite') : t('button.reviewWebsite')}
          onClick={() =>
            validation?.websiteVerifiedAt ? setEditWebsiteModalOpened(true) : setWebsiteModalOpened(true)
          }
          icon={<PencilSVG />}
        />
      )}
      {inputsEditable && (!vrReviewWebsiteFeatureFlag || !validation?.website) && (
        <ListItemButton
          title={t('button.editWebsite')}
          onClick={() => setEditWebsiteModalOpened(true)}
          icon={<PencilSVG />}
        />
      )}
    </NonProfitDetailListItem>
  )
}
